import { przezmorzeApi } from "../../api/api";
import type { DeleteOrderAttachmentResponse, OrderAttachmentResponse } from "@przezmorze/api-types";

export type { OrderAttachmentResponse };

export async function addOrderAttachment(
  orderId: string,
  body: FormData,
  abortSignal?: AbortSignal,
): Promise<OrderAttachmentResponse> {
  const response = await przezmorzeApi.post<OrderAttachmentResponse>(`/orders/${orderId}/attachments`, body, {
    signal: abortSignal,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export async function deleteOrderAttachment(
  orderId: string,
  name: string,
  abortSignal?: AbortSignal,
): Promise<OrderAttachmentResponse[]> {
  const encodedName = btoa(encodeURIComponent(name));
  const response = await przezmorzeApi.delete<DeleteOrderAttachmentResponse>(
    `/orders/${orderId}/attachments/${encodedName}`,
    {
      signal: abortSignal,
    },
  );
  return response.data.items;
}
